import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["user.selectedUser"],
  user => user
);
